import { render } from "./WhoAmI.vue?vue&type=template&id=70386345&scoped=true"
import script from "./WhoAmI.vue?vue&type=script&lang=js"
export * from "./WhoAmI.vue?vue&type=script&lang=js"

import "./WhoAmI.vue?vue&type=style&index=0&id=70386345&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70386345"]])

export default __exports__